import { render } from "./AlergiaPers.vue?vue&type=template&id=9ca261dc&scoped=true"
import script from "./AlergiaPers.vue?vue&type=script&lang=js"
export * from "./AlergiaPers.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=9ca261dc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca261dc"]])

export default __exports__